import "./index.css"
import { useEffect } from "react"
import { Alert, Skeleton } from "@material-ui/lab"
import { useSelector, useDispatch } from "react-redux"
import { obtenerExtraCotizacion } from "../../../ducks/clientesDuck"
import { formatDinero } from './../../../utils/formatDinero'
import { FormatoFechaIso } from './../../../utils/FormatFecha'
import { useContratacion } from "../../../hooks/useContratacion"
import { Box, Divider, Grid, Paper, Typography } from "@material-ui/core"
import { esFinalizado } from "../../../utils/esFinalizado"
import { TapViaje } from "./TapViaje"
const TarjetaExtra = () => {
    const { idCotizacion, extraCotizacion, referencia } = useSelector(store => store.cliente)
    const dispatch = useDispatch()
    const [contratacion] = useContratacion({ referencia })
    const extrasPaquete = contratacion.PaqueteContratado?.ListaSuplementoContratado ?? []

    useEffect(() => {
        dispatch(obtenerExtraCotizacion({ idCotizacion }))
    }, [dispatch, idCotizacion])

    if (contratacion.IdContratacion > 0)
        return (
            <div className="TarjetaExtra-root">
                <div className="contenido" style={{ padding: "20px" }}>

                    <Paper elevation={3} style={{ padding: "16px", margin: "2% 0" }}>
                        <Typography variant="h6" gutterBottom>
                            Información de la Contratación
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1"><strong>Monto contratación:</strong> {formatDinero(contratacion?.MontoContratacion)} {contratacion?.Moneda}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1"><strong>Número de pasajeros:</strong> {contratacion?.NumeroPersonas}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1"><strong>Fecha contratación:</strong> {FormatoFechaIso({ date: contratacion?.FechaContrato, formato: "dd/MM/yyy" })}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1"><strong>Email Agente:</strong> {contratacion?.AgenteEmail}</Typography>
                            </Grid>

                            <Grid item xs={12}><Divider /></Grid>

                            <Grid item xs={12}>
                                <Typography variant="body1"><strong>Nombre paquete:</strong> {contratacion?.PaqueteContratado?.Nombre}</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1"><strong>Precio paquete:</strong> {formatDinero(contratacion?.PaqueteContratado?.Precio)} {contratacion?.Moneda}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body1"><strong>Total:</strong> {formatDinero(contratacion?.PaqueteContratado?.Precio * contratacion?.NumeroPersonas)} {contratacion?.Moneda}</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper elevation={3} style={{ padding: "16px", margin: "2% 0" }}>
                        <Box display="flex" alignItems="stretch" gap={2} style={{ margin: "2% 0" }}>
                            <Box flex={1} style={{ padding: "0 20px" }}>
                                <h4>Incluye</h4>
                                <div dangerouslySetInnerHTML={{ __html: contratacion?.PaqueteContratado?.Descripcion }} />
                            </Box>

                            <Divider orientation="vertical" flexItem />

                            <Box flex={1} style={{ padding: "0 20px" }}>
                                <h4>No Incluye</h4>
                                <div dangerouslySetInnerHTML={{ __html: contratacion?.PaqueteContratado?.NoIncluye }} />
                            </Box>
                        </Box>
                    </Paper>
                    <TapViaje />

                    {/* {
                        extrasPaquete.map((item, index) =>
                            <div key={item.IdExtraPaqueteProveedor} style={{ margin: "2% 0" }}>
                                <h4>{`Tipo suplemento: ${item?.TipoSuplemento}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Cantidad: ${item?.Cantidad}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Monto suplemento: ${formatDinero(item?.Precio)} ${contratacion?.Moneda}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Total: ${formatDinero(item?.Precio * item?.Cantidad)} ${contratacion?.Moneda}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Fecha contratación: ${FormatoFechaIso({date: item?.FechaRegistro, formato: "dd/MM/yyyy"})}`}</h4>
                                <h4>{`Nombre suplemento:`}
                                    <div dangerouslySetInnerHTML={{ __html: `${item?.Nombre}` }} />
                                </h4>
                                <div dangerouslySetInnerHTML={{ __html: `${item?.Descripcion ?? ""}` }} />
                                <Divider />
                            </div>
                        )
                    } */}
                </div>
            </div>
        )

    if (extraCotizacion.length > 0)
        return (
            <div className="TarjetaExtra-root">
                <div className="contenido">
                    {
                        extraCotizacion.map((extra, index) =>
                            <div key={index}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Costo: ${formatDinero(extra.Costo)} ${extra.Moneda.Nombre}`}
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Comision: ${formatDinero(extra.Comision)}`}
                                        </li>
                                    </ul>
                                    <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Cantidad: ${extra.Cantidad}`}
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Total: ${formatDinero(extra.Total)}  ${extra.Moneda.Nombre}`}
                                        </li>
                                    </ul>
                                </div>
                                <div style={{ padding: "20px" }} dangerouslySetInnerHTML={{ __html: `${extra.Extra}` }} />
                            </div>
                        )
                    }
                </div>
            </div>
        )
    return (
        <div className="TarjetaExtra-root">
            <div className="contenido">
                <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
                <Skeleton variant="rect" height={350} />
            </div>
        </div>
    )

}
export default TarjetaExtra